import { client } from '../http';

/// ///////////////// Share Pages ////////////////////
async function getSharePage(sharePageId) {
  const response = await client.get(`/api/no-auth/share-page/${sharePageId}`);
  return response.data;
}

async function createSharePage(sharePage) {
  const response = await client.post('/api/share-page', sharePage);
  return response.data;
}

async function sendAnalytics(sharePageId, eventName) {
  await client.post(`/api/no-auth/share-page/analytics/${sharePageId}`, { eventName });
}

async function sendAnalyticsLoggedIn(sharePageId, eventName) {
  await client.post(`/api/share-page/analytics/${sharePageId}`, { eventName });
}

/// ///////////////// Challenges ////////////////////

async function createChallenge(challengeAmount, ownerParticipantId) {
  const response = await client.post('/api/challenges', { challengeAmount, ownerParticipantId });
  return response.data;
}

async function createParticipant(participantId, firstName, ownerParticipantId) {
  const response = await client.post('/api/no-auth/challenges/participants', {
    participantId,
    firstName,
    ownerParticipantId,
  });
  return response.data;
}

async function createParticipantForCustomer(participantId, firstName, ownerParticipantId) {
  const response = await client.post('/api/challenges/participants', {
    participantId,
    firstName,
    ownerParticipantId,
  });
  return response.data;
}

async function createOwnerParticipant(participantId, firstName) {
  const response = await client.post('/api/challenges/participants/owner', {
    participantId,
    firstName,
  });
  return response.data;
}

async function startChallenge(challengeOwnerId) {
  const response = await client.post(`/api/no-auth/challenges/${challengeOwnerId}/start`);
  return response.data;
}

async function addParticipantsToChallenge(participants, challengeOwner) {
  const response = await client.put('/api/no-auth/challenges/participants', { participants, owner: challengeOwner });
  return response.data;
}

async function updateParticipant(participant) {
  const response = await client.put(`/api/no-auth/challenges/participants/${participant.participantId}`, participant);
  return response.data;
}

async function getActiveChallengeForMember(participantId) {
  const response = await client.get(`/api/no-auth/challenges/${participantId}`);
  return response.data;
}

async function getChallengeParticipants(challengeOwnerId) {
  const response = await client.get(`/api/no-auth/challenges/${challengeOwnerId}/participants`);
  return response.data;
}

async function getParticipantForCurrentCustomer() {
  const response = await client.get('/api/challenges/customers/participants');
  return response.data;
}

async function updateParticipantSpent(spent, participantId) {
  const response = await client.put(`/api/no-auth/challenges/participants/${participantId}/spent`, { spent });
  return response.data;
}

async function connectParticipantToCustomer(participantId) {
  const response = await client.put(`/api/challenges/participants/${participantId}/customer`);
  return response.data;
}

export default {
  getSharePage,
  createSharePage,
  sendAnalytics,
  sendAnalyticsLoggedIn,
  createChallenge,
  addParticipantsToChallenge,
  getActiveChallengeForMember,
  createParticipant,
  createParticipantForCustomer,
  createOwnerParticipant,
  getChallengeParticipants,
  getParticipantForCurrentCustomer,
  updateParticipantSpent,
  connectParticipantToCustomer,
  startChallenge,
  updateParticipant,
};
